import {decryptKBItemIfEncrypted} from "../App/cryptoUtils";

export const detectTypes = ({isIndexedDB, attrType, index, field}) => {
    let isNumber, isBoolean, isDate, isDateTime, isString = false

    if (['datetime'].includes(attrType) || isIndexedDB && ['createdAt', 'updatedAt'].includes(index) || !isIndexedDB && field === 'updatedAt') {
        isDateTime = true;
    }
    else if (['date'].includes(attrType)) {
        isDate = true;
    }
    else if (['boolean'].includes(attrType)) {
        isBoolean = true;
    } else if (['integer', 'long', 'float', 'double'].includes(attrType) ||
        isIndexedDB && ['totalTokens'].includes(index)) {
        isNumber = true;
    } else if (!isIndexedDB && field === 'itemId' || isIndexedDB) {
        isString = true;
    }

    return { isNumber, isBoolean, isDateTime, isDate, isString }
}

export const convertIndexedItem = (item, store) => {
    const { createdAt, updatedAt, embeddings, embeddingModel, itemId, totalTokens, attributes, ...itemFields } = item;

    return {
        item: itemFields,
        meta: { createdAt, updatedAt, embeddings, embeddingModel, itemId, totalTokens, attributes, itemType: store }
    };
}

export const convertVectorDBItem = (item) => {
    const { createdAt, updatedAt, itemId, totalTokens, attributes, itemType, distance, score, ...itemFields } = item;

    return {
        item: itemFields,
        meta: {
            createdAt,
            updatedAt,
            itemId,
            totalTokens,
            attributes,
            itemType,
            score, // VectorDB similarity score
            distance // VectorDB distance
        }
    };
}

export const decryptItemByAttributes = (item, attributes) => {
    let myItem = {...item};
    Object.keys(myItem).forEach(attrName => {
        const attribute = attributes.find(attr => attr.attrName === attrName);
        myItem[attrName] = attribute?.encrypted ? decryptKBItemIfEncrypted(myItem[attrName]) : myItem[attrName];
    })

    return myItem;
}

export const decryptItemWithMeta = (item) => {
    let myItem = {...item};
    Object.keys(myItem?.item).forEach(attrName => {
        const attribute = myItem?.meta?.attributes.find(a => a.attrName === attrName);
        myItem.item[attrName] = attribute?.encrypted ? decryptKBItemIfEncrypted(myItem.item[attrName]) : myItem.item[attrName];
    })

    return myItem;
}